<template>
  <div>
   
    <div class="sideMenu">
      <nav>
        <a href="#">
          <li class="nav-item">
            <router-link to="/admin/products" class="nav-link">
              <i class="fas fa-box-open"></i> 產品列表
            </router-link>
          </li>
        </a>
        <a href="#">
          <li class="nav-item">
            <router-link to="/admin/order" class="nav-link">
              <i class="fas fa-list-alt"></i> 訂單列表
            </router-link>
          </li>
        </a>
        <a href="#">
          <li class="nav-item">
            <router-link to="/admin/coupons" class="nav-link">
              <i class="fas fa-ticket-alt"></i> 優惠券
            </router-link>
          </li>
        </a>
      </nav>
      <label for="sideMenu-active">
        <i class="fas fa-angle-right"></i>
      </label>
      <!-- label 寫在 nav 下方是為了比較好看到 -->
    </div>
  </div>
</template>

<script>
export default {
  name: "navbar",
  data() {
    return {
      msg: "Welcome to Your Vue.js App"
    };
  },
  methods: {
    signout() {
      const api = `${process.env.APIPATH}/logout`;
      const vm = this;
      this.$http.post(api).then(response => {
        console.log(response.data);
        if (response.data.success) {
          vm.$router.push("/Login");
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
html,
body {
  height: 100%;
}

body {
  background-color: #546377;
  box-sizing: border-box;
  font-family: "Noto Sans TC", sans-serif;
}

.container {
  width: 100%;
  padding-right: 15px;
  margin-left: -15px;
}

a {
  text-decoration: none;
  font-weight: 300;
  &:hover {
    color: yellow;
  }
}
a,
label {
  cursor: pointer;
}

.sideMenu {
  width: 300px;
  background-color: #ff7575;
  border-right: 3px solid #d1d1d1;
  display: flex;
  top: 95px;
  flex-direction: column; //主軸
  // padding: 50px 0;
  box-shadow: 5px 0 5px rgba(23, 23, 54, 0.6);
  position: fixed; // label 定位在這個上
  transform: translateX(-100%); // 將 sideMenu 左橫移 100%，使他到螢幕外
  transition: 0.5s; // 側邊選單收合的時間差

  form {
    display: flex;
    margin: 0 10px 50px;
    border-radius: 100px;
    border: 1px solid #fff;
    input {
      width: 230px;
    }
    button {
      width: 50px;
    }
    input,
    button {
      border: none;
      padding: 5px 10px;
      background-color: transparent;
      color: #fff;
      &:focus {
        outline: none;
      }
    }
  }

  label {
    width: 20px;
    height: 80px;
    background-color: #d1d1d1;
    color: #686666;
    // 絕對定位在 sideMenu 上
    position: absolute;
    right: -20px;
    top: 0;
    bottom: 0;
    margin: auto;
    line-height: 80px;
    text-align: center;
    border-radius: 0 5px 5px 0;
    box-shadow: 5px 0 5px rgba(23, 23, 54, 0.6);
  }
}

#sideMenu-active:checked + .sideMenu {
  transform: translateX(0);

  // 當我點擊 sideMenu 時，checkbox 會啟動 id，讓側邊選單跑出來
  label .fas {
    transform: scaleX(-1); // 使 label 裡的圖案橫向反轉
  }
}

#sideMenu-active {
  position: absolute;
  opacity: 0; //使 checkbox 變透明
  z-index: -1; // 為了保險不要讓該功能還選得到，可將其排序往後跳
}

nav {
  a {
    display: block;
    color: #fff;
    padding: 20px 10px;
    position: relative;

    .fas {
      margin-right: -1.1em;
      transform: scale(0);
      //使圖示消失
      transition: 0.3s;
    }

    &:hover .fas {
      margin-right: 0em; //使文字回到原來的位置
      transform: scale(1); //使圖示出現
    }

    & + a::before {
      content: "";
      position: absolute;
      border-top: 1px dashed #ffffff;
      left: 10px;
      right: 10px;
      top: 0px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Backend/NavBar.vue